import { render } from "./innovaDetail.vue?vue&type=template&id=68777f2a&scoped=true"
import script from "./innovaDetail.vue?vue&type=script&lang=js"
export * from "./innovaDetail.vue?vue&type=script&lang=js"

import "./innovaDetail.vue?vue&type=style&index=0&id=68777f2a&lang=less&scoped=true"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68777f2a"]])

export default __exports__